import { ModicaDropdown, ModicaDropdownOption } from "@modica-library/dropdown/react";
import { useId, useState, type FC, type ReactNode } from "react";

export type Option = { label: string; value: string };

type Props = {
  label?: string;
  options: Option[];
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
};

// The react wrapper's typed props omit `onChange`; the underlying custom element emits a
// `change` CustomEvent carrying { value }. Cast to the shape we actually use. We deliberately
// do NOT pass `class`/`label` — passing `class={undefined}` makes the web component throw
// (`.includes` of undefined) on render, per the working usage in sibling apps.
const MDropdown = ModicaDropdown as unknown as FC<{
  id?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (event: CustomEvent<{ value?: string }>) => void;
  children?: ReactNode;
}>;

export function Dropdown({ options, value, onChange }: Props) {
  const id = useId();
  const [selected, setSelected] = useState(value ?? options[0]?.value ?? "");
  return (
    <MDropdown
      id={id}
      value={selected}
      onChange={(event) => {
        const v = event.detail?.value ?? "";
        setSelected(v);
        onChange?.(v);
      }}
    >
      {options.map((o) => (
        <ModicaDropdownOption key={o.value} value={o.value}>
          {o.label}
        </ModicaDropdownOption>
      ))}
    </MDropdown>
  );
}
